import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { api } from './services/api';

export type CabinetLang = 'ru' | 'kk';

const COPY = {
  ru: {
    language: 'Язык',
    edoSubtitle: 'Система электронного документооборота',
    company: 'Компания',
    profileMenu: 'Меню профиля',
    settings: 'Настройки',
    logout: 'Выйти',
    documents: 'Документы',
    avrTitle: 'Акты выполненных работ',
    loginEds: 'Вход в систему осуществляется с помощью ключа ЭЦП (NCALayer)',
    chooseCert: 'Выбрать сертификат',
    waitingEds: 'Ожидание ЭЦП…',
    downloadNca: 'Скачать NCALayer',
    signCanceled: 'Подпись отменена',
    ncalayerError: 'Ошибка NCALayer',
    loginError: 'Ошибка входа',
    pcs: 'шт.',
    period: 'Период',
    avr: 'АВР',
    all: 'Все',
    outgoing: 'Исходящие',
    incoming: 'Входящие',
    outgoingAvr: 'Исходящий АВР',
    incomingAvr: 'Входящий АВР',
    status: 'Статус',
    pending: 'На подписании',
    signed: 'Подписан',
    cancelled: 'Аннулирован',
    rejected: 'Отклонён',
    search: 'Поиск',
    searchPlaceholder: 'Номер, отправитель, ИИН…',
    resetPeriod: 'Сбросить период',
    sign: 'Подписать',
    signing: 'Подпись',
    selectPage: 'Выбрать на странице',
    unselectPage: 'Снять на странице',
    selectAll: 'Выбрать все',
    unselectAll: 'Снять выбор',
    selected: 'Выбрано',
    loading: 'Загрузка…',
    noDocuments: 'Нет документов',
    type: 'Тип',
    customer: 'Заказчик',
    executor: 'Исполнитель',
    back: 'Назад',
    backToList: 'Вернуться к списку документов',
    notFound: 'Документ не найден',
    loadError: 'Ошибка загрузки',
    ncalayerConnect: 'Не удалось подключиться к NCALayer.\nСкачать: https://ncl.pki.gov.kz/',
    pickToSign: 'Выберите документы для подписания',
    noPdf: 'Нет PDF',
    canceledInNca: 'Отменено в NCALayer',
    signedCount: 'Подписано',
    rejectedByYandex: 'Отклонено Яндексом',
    rejectedByDrivers: 'Отклонено водителями',
    of: 'из',
    next: 'Вперёд',
    prev: 'Назад',
    waitDriver: 'Ожидает подписания водителя',
    waitYandex: 'Ожидает подписания Яндекс',
    waitSend: 'Ожидает отправки',
    sent: 'Отправлено',
    processing: 'Готовится',
    overdue: 'Просрочен',
    downloadPdf: 'Скачать PDF',
    downloadZip: 'Скачать ZIP',
    copySignLink: 'Копировать ссылку на подписание',
    linkCopied: 'Ссылка скопирована',
    copyLinkFailed: 'Не удалось скопировать ссылку',
    pdfPending: 'PDF ещё формируется. Обновите страницу через несколько секунд.',
    signers: 'Подписанты документа',
    noSignatures: 'Подписей пока нет',
    signedMark: 'Подписано',
    showSigners: 'Показать подписантов',
    regNo: 'Рег. №',
    uploadedAt: 'Дата загрузки',
    driver: 'Водитель',
    accountant: 'Бухгалтер',
    yandex: 'Яндекс',
    iinBin: 'ИИН/БИН',
    phone: 'Телефон',
    noPhone: 'Нет данных',
    users: 'Пользователи',
    apiKeys: 'API ключи',
    companyData: 'Данные компании',
    name: 'Название',
    bin: 'БИН',
    address: 'Адрес',
    companyActive: 'активна',
    companyInactive: 'неактивна',
    companySuspended: 'приостановлена',
    add: 'Добавить',
    userHint: 'ФИО и ИИН. Вход в кабинет — только через ЭЦП (NCALayer).',
    fullName: 'Имя',
    iin: 'ИИН',
    iin12: '12 цифр',
    save: 'Сохранить',
    saving: 'Добавление…',
    cancel: 'Отмена',
    noUsers: 'Пользователей пока нет',
    userActive: 'активен',
    userDisabled: 'отключён',
    userAdded: 'Пользователь добавлен (вход по ЭЦП)',
    userAddFailed: 'Не удалось добавить пользователя',
    settingsLoadFailed: 'Ошибка загрузки настроек',
    keyName: 'Название ключа',
    creating: 'Создание…',
    noKeys: 'Ключей пока нет',
    prefix: 'Префикс',
    revoke: 'отозвать',
    revokeConfirm: 'Отозвать этот API-ключ?',
    keyCreated: 'API-ключ создан. Скопируйте его сейчас — повторно показать нельзя.',
    keyCreateFailed: 'Не удалось выпустить ключ',
    keyRevoked: 'API-ключ отозван',
    keyRevokeFailed: 'Не удалось отозвать ключ',
    copyNow: 'Новый ключ — скопируйте сейчас',
    copy: 'Копировать',
    revoked: 'отозван',
    months: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
  },
  kk: {
    language: 'Тіл',
    edoSubtitle: 'Электрондық құжат айналымы жүйесі',
    company: 'Компания',
    profileMenu: 'Профиль мәзірі',
    settings: 'Баптаулар',
    logout: 'Шығу',
    documents: 'Құжаттар',
    avrTitle: 'Орындалған жұмыстар актілері',
    loginEds: 'Жүйеге кіру ЭЦҚ кілті (NCALayer) арқылы жүзеге асырылады',
    chooseCert: 'Сертификатты таңдау',
    waitingEds: 'ЭЦҚ күтілуде…',
    downloadNca: 'NCALayer жүктеу',
    signCanceled: 'Қол қою тоқтатылды',
    ncalayerError: 'NCALayer қатесі',
    loginError: 'Кіру қатесі',
    pcs: 'дана',
    period: 'Кезең',
    avr: 'АВР',
    all: 'Барлығы',
    outgoing: 'Шығыс',
    incoming: 'Кіріс',
    outgoingAvr: 'Шығыс АВР',
    incomingAvr: 'Кіріс АВР',
    status: 'Мәртебе',
    pending: 'Қол қойылуда',
    signed: 'Қол қойылған',
    cancelled: 'Жойылған',
    rejected: 'Қабылданбаған',
    search: 'Іздеу',
    searchPlaceholder: 'Нөмір, жіберуші, ЖСН…',
    resetPeriod: 'Кезеңді тастау',
    sign: 'Қол қою',
    signing: 'Қол қою',
    selectPage: 'Беттегісін таңдау',
    unselectPage: 'Беттегісін алу',
    selectAll: 'Барлығын таңдау',
    unselectAll: 'Таңдауды алу',
    selected: 'Таңдалды',
    loading: 'Жүктелуде…',
    noDocuments: 'Құжаттар жоқ',
    type: 'Түрі',
    customer: 'Тапсырыс беруші',
    executor: 'Орындаушы',
    back: 'Артқа',
    backToList: 'Құжаттар тізіміне оралу',
    notFound: 'Құжат табылмады',
    loadError: 'Жүктеу қатесі',
    ncalayerConnect: 'NCALayer-ге қосылу мүмкін болмады.\nЖүктеу: https://ncl.pki.gov.kz/',
    pickToSign: 'Қол қою үшін құжаттарды таңдаңыз',
    noPdf: 'PDF жоқ',
    canceledInNca: 'NCALayer-де тоқтатылды',
    signedCount: 'Қол қойылды',
    rejectedByYandex: 'Яндекс қабылдамаған',
    rejectedByDrivers: 'Жүргізушілер қабылдамаған',
    of: '/',
    next: 'Алға',
    prev: 'Артқа',
    waitDriver: 'Жүргізушінің қол қоюын күтуде',
    waitYandex: 'Яндекстің қол қоюын күтуде',
    waitSend: 'Жіберуді күтуде',
    sent: 'Жіберілді',
    processing: 'Дайындалуда',
    overdue: 'Мерзімі өткен',
    downloadPdf: 'PDF жүктеу',
    downloadZip: 'ZIP жүктеу',
    copySignLink: 'Қол қою сілтемесін көшіру',
    linkCopied: 'Сілтеме көшірілді',
    copyLinkFailed: 'Сілтемені көшіру мүмкін болмады',
    pdfPending: 'PDF әлі дайындалуда. Бетті бірнеше секундтан кейін жаңартыңыз.',
    signers: 'Құжатқа қол қоюшылар',
    noSignatures: 'Қолтаңбалар әзірге жоқ',
    signedMark: 'Қол қойылған',
    showSigners: 'Қол қоюшыларды көрсету',
    regNo: 'Тіркеу №',
    uploadedAt: 'Жүктелген күні',
    driver: 'Жүргізуші',
    accountant: 'Бухгалтер',
    yandex: 'Яндекс',
    iinBin: 'ЖСН/БСН',
    phone: 'Телефон',
    noPhone: 'Дерек жоқ',
    users: 'Пайдаланушылар',
    apiKeys: 'API кілттері',
    companyData: 'Компания деректері',
    name: 'Атауы',
    bin: 'БСН',
    address: 'Мекенжай',
    companyActive: 'белсенді',
    companyInactive: 'белсенді емес',
    companySuspended: 'тоқтатылған',
    add: 'Қосу',
    userHint: 'ТАӘ және ЖСН. Кабинетке кіру — тек ЭЦҚ (NCALayer) арқылы.',
    fullName: 'Аты',
    iin: 'ЖСН',
    iin12: '12 сан',
    save: 'Сақтау',
    saving: 'Қосылуда…',
    cancel: 'Болдырмау',
    noUsers: 'Пайдаланушылар әзірге жоқ',
    userActive: 'белсенді',
    userDisabled: 'өшірілген',
    userAdded: 'Пайдаланушы қосылды (кіру ЭЦҚ арқылы)',
    userAddFailed: 'Пайдаланушыны қосу мүмкін болмады',
    settingsLoadFailed: 'Баптауларды жүктеу қатесі',
    keyName: 'Кілт атауы',
    creating: 'Жасалуда…',
    noKeys: 'Кілттер әзірге жоқ',
    prefix: 'Префикс',
    revoke: 'қайтарып алу',
    revokeConfirm: 'Осы API-кілтті қайтарып алу керек пе?',
    keyCreated: 'API-кілт жасалды. Қазір көшіріп алыңыз — қайта көрсету мүмкін емес.',
    keyCreateFailed: 'Кілт шығару мүмкін болмады',
    keyRevoked: 'API-кілт қайтарып алынды',
    keyRevokeFailed: 'Кілтті қайтарып алу мүмкін болмады',
    copyNow: 'Жаңа кілт — қазір көшіріп алыңыз',
    copy: 'Көшіру',
    revoked: 'қайтарып алынған',
    months: [
      'Қаңтар',
      'Ақпан',
      'Наурыз',
      'Сәуір',
      'Мамыр',
      'Маусым',
      'Шілде',
      'Тамыз',
      'Қыркүйек',
      'Қазан',
      'Қараша',
      'Желтоқсан',
    ],
  },
};

export type CabinetCopy = (typeof COPY)['ru'];

export function normalizeCabinetLang(raw?: string | null): CabinetLang {
  return raw === 'kk' ? 'kk' : 'ru';
}

type LangContextValue = {
  lang: CabinetLang;
  setLang: (lang: CabinetLang) => void;
  t: CabinetCopy;
};

const LangContext = createContext<LangContextValue>({
  lang: 'ru',
  setLang: () => undefined,
  t: COPY.ru,
});

export function LangProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<CabinetLang>(() => normalizeCabinetLang(api.getUiLang()));
  const setLang = useCallback((next: CabinetLang) => {
    setLangState(next);
    api.setUiLang(next);
  }, []);
  const value = useMemo(() => ({ lang, setLang, t: COPY[lang] }), [lang, setLang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useCabinetLang() {
  return useContext(LangContext);
}

export function LangSelect({ className }: { className?: string }) {
  const { lang, setLang, t } = useCabinetLang();
  return (
    <div className={className || 'lang-switch'} role="group" aria-label={t.language}>
      <button
        type="button"
        className={lang === 'ru' ? 'active' : undefined}
        aria-pressed={lang === 'ru'}
        onClick={() => setLang('ru')}
      >
        RU
      </button>
      <button
        type="button"
        className={lang === 'kk' ? 'active' : undefined}
        aria-pressed={lang === 'kk'}
        onClick={() => setLang('kk')}
      >
        KZ
      </button>
    </div>
  );
}

export function statusText(t: CabinetCopy, key: string): string {
  const map: Record<string, string> = {
    WAIT_DRIVER: t.waitDriver,
    WAIT_YANDEX: t.waitYandex,
    WAIT_SEND: t.waitSend,
    SENT: t.sent,
    COMPLETED: t.signed,
    PROCESSING: t.processing,
    OVERDUE: t.overdue,
    CANCELLED: t.cancelled,
    REJECTED: t.rejected,
    NEW: t.waitDriver,
    IN_PROGRESS: t.waitDriver,
    SIGNED_BY_DRIVER: t.waitYandex,
    SIGNED_BY_YANDEX: t.waitDriver,
    SIGNED_BY_ACCOUNTANT: t.waitDriver,
  };
  return map[key] || key;
}
